<template>
    <div class="settings-external-plugins">
        <ul v-if="plugins.length > 0" class="settings-external-plugins__list">
            <li
                v-for="(plugin, indexPlugin) in sortedPlugins"
                :key="indexPlugin"
                class="settings-external-plugins__list-item"
            >
                <a :href="plugin.url" @click="handleClickPlugin(plugin)">
                    <CompassIcon
                        v-if="plugin.isSlsyIcon"
                        :customFile="pathSlsyIcon(plugin.iconSvg)"
                        :customIcon="plugin.iconSvg"
                        class="compassIcon"
                    />
                    <SaasIcon v-else height="40" width="40" :icon="plugin.iconSvg" />
                    <span class="typographies-paragraph-medium-semibold">{{ plugin.label }}</span>
                </a>
            </li>
        </ul>
        <div v-else class="placeholder">
            <p>{{ $l10n.__("Vous n'avez pas de module externe") }}</p>
        </div>
        <div v-if="permissions.can_add_module" class="settings-external-plugins__add-module">
            <CompassButton
                :label="$t.__('settings.SettingsInternalPlugin.add_modules')"
                type="secondary"
                @click="redirectionAddModules"
            />
        </div>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import SaasIcon from 'vcomponents/common/SaasIcon.vue';
import { goToUrl } from 'vueDir/helpers.js';
const settingsStore = createNamespacedHelpers('settingsStore');

export default {
    components: { SaasIcon },
    props: {
        pluginPrefsToLoad: {
            type: String,
            required: false,
            validator(value) {
                return ['GoogleSync', 'GoogleDrive', 'OutlookSync'].includes(value);
            },
        },
    },
    computed: {
        ...settingsStore.mapGetters({
            plugins: 'getExternalPlugins',
            permissions: 'getPermissions',
        }),
        sortedPlugins() {
            return this.plugins.toSorted((a, b) => {
                return a.label.localeCompare(b.label);
            });
        },
        pathSlsyIcon() {
            return (icon) => require(`svg/${icon}.svg?pathOnly`).default;
        },
    },
    created() {
        if (this.pluginPrefsToLoad) {
            this.openPrefs();
        }
    },
    methods: {
        /**
         * Open legacy preferences popup for some modules.
         * @see this.pluginPrefsToLoad
         */
        openPrefs() {
            eval(this.pluginPrefsToLoad).loadPrefs();
        },
        handleClickPlugin(plugin) {
            if (plugin.call) {
                eval(plugin.call);
            }
        },
        redirectionAddModules() {
            return goToUrl('/?_f=store&amp;showme=apps');
        },
    },
};
</script>
<style lang="scss" scoped>
.settings-external-plugins {
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-between;
    &__list {
        display: grid;
        gap: var(--spacing-5);
        grid-template-columns: repeat(6, 1fr);
        margin: 0;

        &-item {
            a {
                align-items: center;
                border-radius: var(--spacing-0);
                color: var(--colors-common-text-subtle-default);
                cursor: pointer;
                display: flex;
                flex-direction: column;
                gap: var(--spacing-1);
                height: 100%;
                padding: var(--spacing-1) var(--spacing-2);
                text-align: center;
                text-decoration: none;

                &:hover {
                    background: var(--colors-common-background-hover);
                    color: var(--colors-common-text-subtle-hover);
                }
            }

            .compassIcon {
                height: 40px;
                width: 40px;
            }
        }
    }

    &__add-module {
        display: flex;
        justify-content: end;
    }
}
</style>
